import React, { useEffect } from 'react';
import { FiLock, FiUnlock } from 'react-icons/fi';
import confetti from './img/confetti.svg';
import { GuideBlockNav, GuideBlockNavCheck, GuideBlockNavIcon, GuideBlockNavItem, GuideBlockNavTitle } from '@/components/custom/guide';

export function StudyGuideBlockNav(props) {
  const { data, finished, setActiveSectionIndex, activeSectionIndex } = props;

  const getIndexOfClickedSection = id => {
    const index = data.findIndex(s => s.id === id);
    setActiveSectionIndex(index);
  };

  useEffect(() => {
    const index = data.findIndex(s => s.isActive || !s.done);
    if (index === -1) setActiveSectionIndex(0);
    else setActiveSectionIndex(index);
  }, [data]);

  return (
    <GuideBlockNav>
      {data.map((section, index, arr) => {
        const lastItem = arr.length - 1;
        const active = activeSectionIndex;

        return (
          <GuideBlockNavItem
            isActive={section.isActive}
            isSuccess={active === index}
            style={{ cursor: section.done || index === data.findIndex(s => !s.done) ? 'pointer' : 'default' }}
            key={index}
            onClick={() => {
              if (section.done || index === data.findIndex(s => !s.done)) getIndexOfClickedSection(section.id);
            }}
          >
            <GuideBlockNavIcon
              isActive={section.isActive}
              isSuccess={active === index}
            >
              {index === lastItem && finished ? (
                <img
                  src={confetti}
                  alt="confetes"
                />
              ) : section.isActive || section.done ? (
                <FiUnlock />
              ) : (
                <FiLock />
              )}
            </GuideBlockNavIcon>
            <GuideBlockNavTitle
              title={section.title}
              isSuccess={active === index}
            >
              {section.title === 'questions' ? 'Avaliação de conhecimento' : section.title}
            </GuideBlockNavTitle>
            <GuideBlockNavCheck
              checked={index === lastItem && finished ? true : section.done}
              readOnly
              isSuccess={active === index}
            />
          </GuideBlockNavItem>
        );
      })}
    </GuideBlockNav>
  );
}
